// MostViewed.jsx
import React, { useState } from "react";
import { useAgentsLocal } from "./useAgentsLocal";
import { FiEye } from "react-icons/fi";
import LexacquireTopnav from "./lexacquiretopnav";
import "./MostViewed.css";

export default function MostViewed() {
  const { agents, loading } = useAgentsLocal();
  const [selectedAgent, setSelectedAgent] = useState(null);

  // Compute top 10 by viewCount (descending)
  const viewLeaders = React.useMemo(() => {
    return [...agents]
      .sort((a, b) => (b.viewCount || 0) - (a.viewCount || 0))
      .slice(0, 10);
  }, [agents]);

  const openModal = (agent) => {
    setSelectedAgent(agent);
  };

  const closeModal = () => {
    setSelectedAgent(null);
  };

  return (
    <div className="mostviews-page">
      {/* ─── TOP NAV ─── */}
      <LexacquireTopnav />

      {loading ? (
        <p className="mostviews-loading">Loading…</p>
      ) : (
        <>
          <h2>Most Viewed AI Agents</h2>
          <p className="mostviews-subtitle">
            These agents have the highest view counts across our marketplace.
          </p>

          {viewLeaders.length === 0 ? (
            <p className="mostviews-note">No agents to display.</p>
          ) : (
            <div className="mostviews-grid">
              {viewLeaders.map((agent) => {
                const views = agent.viewCount || 0;
                return (
                  <div key={agent.id} className="mostviews-card">
                    {agent.logo ? (
                      <img
                        src={agent.logo}
                        alt={agent.name}
                        className="mostviews-logo"
                      />
                    ) : (
                      <div className="mostviews-logo-placeholder" />
                    )}
                    <div className="mostviews-info">
                      <h3 className="mostviews-name">{agent.name}</h3>
                      <p className="mostviews-desc">{agent.description}</p>
                    </div>
                    <div className="mostviews-metric">
                      <FiEye /> {views.toLocaleString()}
                    </div>
                    <button
                      className="mostviews-link"
                      onClick={() => openModal(agent)}
                    >
                      Learn More →
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}

      {/* ─── MODAL POPUP ─── */}
      {selectedAgent && (
        <div className="mostviews-modal-overlay" onClick={closeModal}>
          <div
            className="mostviews-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="mostviews-modal-close" onClick={closeModal}>
              ×
            </button>
            <div className="mostviews-modal-body">
              {selectedAgent.logo ? (
                <img
                  src={selectedAgent.logo}
                  alt={selectedAgent.name}
                  className="modal-agent-logo"
                />
              ) : (
                <div className="modal-logo-placeholder" />
              )}
              <h2 className="modal-agent-name">{selectedAgent.name}</h2>
              <p className="modal-agent-description">
                {selectedAgent.description}
              </p>
              {selectedAgent.industry && (
                <p>
                  <strong>Industry:</strong> {selectedAgent.industry}
                </p>
              )}
              {selectedAgent.category && (
                <p>
                  <strong>Category:</strong> {selectedAgent.category}
                </p>
              )}
              {selectedAgent.overview && (
                <>
                  <h3>Overview</h3>
                  <p>{selectedAgent.overview}</p>
                </>
              )}
              {selectedAgent.key_features && selectedAgent.key_features.length > 0 && (
                <>
                  <h3>Key Features</h3>
                  <ul>
                    {selectedAgent.key_features.map((feat, idx) => (
                      <li key={idx}>{feat}</li>
                    ))}
                  </ul>
                </>
              )}
              {selectedAgent.use_cases && selectedAgent.use_cases.length > 0 && (
                <>
                  <h3>Use Cases</h3>
                  <ul>
                    {selectedAgent.use_cases.map((useCase, idx) => (
                      <li key={idx}>{useCase}</li>
                    ))}
                  </ul>
                </>
              )}
              {selectedAgent.website_url && (
                <p>
                  <strong>Official Site:</strong>{" "}
                  <a
                    href={selectedAgent.website_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {selectedAgent.website_url}
                  </a>
                </p>
              )}
            
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
